import React from 'react'
import { styled } from '@mui/material/styles'
import { Paper } from '@mui/material'
import PropTypes from 'prop-types'
import Typography from '../Typography/Typography'
import Error from '@mui/icons-material/Error'
import Warning from '@mui/icons-material/Warning'
import Info from '@mui/icons-material/Info'

const PREFIX = 'PageBanner'

const classes = {
  banner: `${PREFIX}-banner`,
  icon: `${PREFIX}-icon`,
}

const banner = {
  info: {
    backgroundColor: '#E7EDFA',
    iconColor: '#224FCA',
    buttonColor: '#224FCA',
  },
  warning: {
    backgroundColor: '#FCEDE0',
    iconColor: '#E86900',
    buttonColor: '#224FCA',
  },
  error: {
    backgroundColor: '#F9E0E0',
    iconColor: '#CC0000',
    buttonColor: '#224FCA',
  },
}

const StyledPaper = styled(Paper)(props => {
  return {
    [`&.${classes.banner}`]: {
      backgroundColor: banner[props.variant].backgroundColor,
      padding: '4px 8px',

      '& p': {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: 0,
        lineHeight: 'normal',
      },

      '& span.message': {
        fontSize: 12,
        paddingLeft: 8,
        lineHeight: 'normal',
      },

      '& button': {
        margin: 8,
        fontSize: 12,
        lineHeight: 0,
        height: 24,
        color: banner[props.variant].buttonColor,
      },
    },
    [`& .${classes.icon}`]: {
      color: banner[props.variant].iconColor,
      fontSize: '1.25rem',
    },
  }
})

const PageBanner = props => {
  const { variant, children } = props
  return (
    <StyledPaper className={classes.banner} variant={variant}>
      <Typography variant="body2">
        {variant === 'info' && <Info className={classes.icon} />}
        {variant === 'warning' && <Warning className={classes.icon} />}
        {variant === 'error' && <Error className={classes.icon} />}
        {children}
      </Typography>
    </StyledPaper>
  )
}

PageBanner.propTypes = {
  variant: PropTypes.string.isRequired,
}

export default PageBanner
